var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Decimal from 'decimal.js';
import { Box, Divider } from 'wix-style-react';
import { DepositType } from '@wix/ambassador-wix-quotes-web/types';
import { hasDeposit } from '../../../DocParts/Totals/Deposit/hasDeposit';
import { Amount } from '../Amount';
import { InfoLine } from '../InfoSection';
export var InvoiceSummary = function (_a) {
    var formatMoney = _a.formatMoney, balance = _a.balance, deposit = _a.deposit, discount = _a.discount, fees = _a.fees, paid = _a.paid, subtotal = _a.subtotal, taxes = _a.taxes, total = _a.total, showTaxBreakdown = _a.showTaxBreakdown, t = _a.t;
    var isDepositDue = hasDeposit({
        depositAmount: deposit.amount,
        paidAmount: paid,
    });
    var AmountWithFormatter = function (props) { return React.createElement(Amount, __assign({ formatMoney: formatMoney }, props)); };
    var renderFees = function () {
        return fees.map(function (_a, index) {
            var name = _a.name, price = _a.price;
            return (React.createElement(AmountWithFormatter, { key: "".concat(name, "-").concat(index), title: name, amount: price }));
        });
    };
    var renderTaxes = function () {
        if (showTaxBreakdown) {
            return taxes.map(function (tax, index) { return (React.createElement(AmountWithFormatter, { key: "".concat(tax.name, "-").concat(tax.rate, "-").concat(index), title: "".concat(tax.name, " (").concat(tax.rate, "%)"), amount: tax.amount })); });
        }
        return (React.createElement(AmountWithFormatter, { title: t('price-quote.view.totals.taxes'), amount: taxes
                .reduce(function (sum, tax) { return sum.add(tax.amount); }, new Decimal(0))
                .toNumber() }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoLine, { heading: true, paddingTop: "24px" }, t('price-quote.mobile-view.totals.title')),
        React.createElement(AmountWithFormatter, { marginTop: "12px", title: t('quote.form.net-total'), amount: subtotal }),
        renderFees(),
        discount.rate > 0 && (React.createElement(AmountWithFormatter, { title: t('price-quote.view.totals.discount', { rate: discount.rate }), amount: -1 * discount.amount })),
        renderTaxes(),
        React.createElement(AmountWithFormatter, { weight: "bold", marginTop: "8px", title: t('quoteview.uou_total'), amount: total }),
        isDepositDue && (React.createElement(AmountWithFormatter, { title: deposit.type === DepositType.PERCENTAGE
                ? t('quoteview.uou_percentage_deposit', {
                    percentage: deposit.rate,
                })
                : "".concat(t('quote.form.deposit')), amount: deposit.amount })),
        React.createElement(AmountWithFormatter, { title: t('quote.form.amount_paid'), amount: -1 * paid }),
        React.createElement(Box, { marginTop: "12px" },
            React.createElement(Divider, null)),
        React.createElement(AmountWithFormatter, { heading: true, marginTop: "12px", title: isDepositDue ? t('quote.form.deposit-due') : t('quote.form.balance'), amount: isDepositDue ? Decimal.sub(deposit.amount, paid).toNumber() : balance })));
};
//# sourceMappingURL=InvoiceSummary.js.map